import { HOMEPAGE_VERSION } from "../../../utils/homepageVersion";

/** @param {"new"|"old"} version @returns {"new"|"old"} the other homepage */
export const otherVersion = (version) =>
  version === HOMEPAGE_VERSION.NEW ? HOMEPAGE_VERSION.OLD : HOMEPAGE_VERSION.NEW;

/** Adds `version` to `list` unless it is already there (keeps order, so slots never reorder). */
export const withVersion = (list, version) =>
  list.includes(version) ? list : [...list, version];
